import { Button } from '@cian/ui-kit';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { useSelector } from 'react-redux';
import { selectFormStatus } from '../../selectors/form';

interface ISuccessFormProps {
  onClick: VoidFunction;
  title: string;
  description: string;
}

export const ModalStatusForm: React.FC<ISuccessFormProps> = ({ onClick, title, description }) => {
  const status = useSelector(selectFormStatus);

  return (
    <div className={style['container']}>
      <div className={clsx(style['image'], style[status])} />
      <div className={style['title']}>{title}</div>
      <div className={style['descr']}>{description}</div>
      <div className={style['btn']}>
        <Button fullWidth onClick={onClick}>
          Хорошо
        </Button>
      </div>
    </div>
  );
};
